export const DOCUMENT_DETAILS_DRAWER = {
    'DOCUMENT.DETAILS.DRAWER.TITLE': 'Detalii document',
    'DOCUMENT.DETAILS.DRAWER.CLIENT_NAME': 'Nume client:',
    'DOCUMENT.DETAILS.DRAWER.COMPANY_NAME': 'Nume companie:',
    'DOCUMENT.DETAILS.DRAWER.FILE_NAME': 'Nume document:',
    'DOCUMENT.DETAILS.DRAWER.FILE_SIZE': 'Dimensiune MB:',
    'DOCUMENT.DETAILS.DRAWER.CALCULATIONS_ASSOCIATIONS': 'Asocieri calcule:',
    'DOCUMENT.DETAILS.DRAWER.CALCULATIONS_ASSOCIATIONS.COLUMN.YEAR': 'An',
    'DOCUMENT.DETAILS.DRAWER.CALCULATIONS_ASSOCIATIONS.COLUMN.QUARTER': 'Trimestru',
    'DOCUMENT.DETAILS.DRAWER.CALCULATIONS_ASSOCIATIONS.COLUMN.STATEMENT_TYPE': 'Tip declarație',
    'DOCUMENT.DETAILS.DRAWER.CALCULATIONS_ASSOCIATIONS.COLUMN.STEP': 'Pas calculație',
    'DOCUMENT.DETAILS.DRAWER.CALCULATIONS_ASSOCIATIONS.COLUMN.ASSOCIATION_DATE': 'Dată asociere',
    'DOCUMENT.DETAILS.DRAWER.CALCULATIONS_ASSOCIATIONS.COLUMN.ASSOCIATED_BY': 'De către'
};
